import { render, staticRenderFns } from "./CaseDrawer.vue?vue&type=template&id=b9de6324&scoped=true"
import script from "./CaseDrawer.vue?vue&type=script&lang=js"
export * from "./CaseDrawer.vue?vue&type=script&lang=js"
import style0 from "./CaseDrawer.vue?vue&type=style&index=0&id=b9de6324&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9de6324",
  null
  
)

export default component.exports